import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './brand.reducer';

export const BrandDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const brandEntity = useAppSelector(state => state.brand.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="brandDetailsHeading">
          <Translate contentKey="tycheApp.brand.detail.title">Brand</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.brand.id">Id</Translate>
            </span>
          </dt>
          <dd>{brandEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tycheApp.brand.name">Name</Translate>
            </span>
          </dt>
          <dd>{brandEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tycheApp.brand.description">Description</Translate>
            </span>
          </dt>
          <dd>{brandEntity.description}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="tycheApp.brand.category">Category</Translate>
            </span>
          </dt>
          <dd>{brandEntity.category}</dd>
          <dt>
            <span id="logo">
              <Translate contentKey="tycheApp.brand.logo">Logo</Translate>
            </span>
          </dt>
          <dd>{brandEntity.logo}</dd>
          <dt>
            <span id="coverPhoto">
              <Translate contentKey="tycheApp.brand.coverPhoto">Cover Photo</Translate>
            </span>
          </dt>
          <dd>{brandEntity.coverPhoto}</dd>
          <dt>
            <span id="isDraft">
              <Translate contentKey="tycheApp.brand.isDraft">Is Draft</Translate>
            </span>
          </dt>
          <dd>{brandEntity.isDraft ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="tycheApp.brand.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>{brandEntity.createdAt ? <TextFormat value={brandEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="tycheApp.brand.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>{brandEntity.updatedAt ? <TextFormat value={brandEntity.updatedAt} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
        </dl>
        <Button tag={Link} to="/brand" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/brand/${brandEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BrandDetail;
